module.exports = __webpack_public_path__ + "static/img/3876_phase_function_Paper_Points.d12435f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3876_phase_function_Paper_Points.png
// module id = uw/x
// module chunks = 0